import { WHO_WE_SERVE } from "../../data/content";

export default function WhoWeServe() {
  return (
    <section className="py-24 lg:py-32 border-t border-white/5 bg-navy-900/50" data-testid="who-we-serve-section">
      <div className="container-x">
        <p className="section-label">WHO WE SERVE</p>
        <h2 className="mt-5 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white max-w-3xl">
          BUILT FOR BUSINESSES THAT <span className="text-flame">VALUE SPEED.</span>
        </h2>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {WHO_WE_SERVE.map((w, i) => (
            <div key={w.title} data-testid={`serve-${w.title.toLowerCase().replace(/\s+/g, "-")}`} className="rounded-2xl border border-white/10 bg-navy-800 p-7 card-lift">
              <p className="font-mono text-[10px] tracking-[0.3em] text-flame">{String(i + 1).padStart(2, "0")}</p>
              <h3 className="mt-4 font-heading text-lg font-bold text-white">{w.title}</h3>
              <p className="mt-3 text-xs text-slate-400 leading-relaxed">{w.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
